// tracking-base-module.js
// ?001 => Google, ?002 => X, ?003 => TikTok

const CONFIG = {
  mode: "strict", // "strict" = パラメータ一致のみ, "all" = 常時全部
  ids: {
    google: "AW-17423045371", // Google広告ID
    tiktok: "D2K2V93C77U067DPRPC0",    // TikTok Pixel ID
    // XはIDを使わず、提供されたコードをそのまま出力する
  }
};

// パラメータ判定
function detectMedium() {
  const q = window.location.search || "";
  if (/(?:^\?|&)company_cd=000010(?:&|$)/.test(q)) return "google";
  if (/(?:^\?|&)company_cd=000011(?:&|$)/.test(q)) return "x";
  if (/(?:^\?|&)company_cd=000012(?:&|$)/.test(q)) return "tiktok";
  return null;
}

// body直後にスクリプト差し込み
function insertScript(code, src) {
  const s = document.createElement("script");
  if (src) {
    s.async = true;
    s.src = src;
  } else {
    s.textContent = code;
  }
  const insert = () => {
    if (!document.body) {
      requestAnimationFrame(insert);
      return;
    }
    if (document.body.firstChild) {
      document.body.insertBefore(s, document.body.firstChild);
    } else {
      document.body.appendChild(s);
    }
  };
  insert();
}

// Google
function injectGoogle(id) {
  insertScript("", `https://www.googletagmanager.com/gtag/js?id=${id}`);
  insertScript(`
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${id}');
  `);
}

// TikTok
function injectTikTok(pid) {
  insertScript(`
    !function (w, d, t) {
      w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];
      ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],
      ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};
      for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);
      ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},
      ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;
        ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};
        n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;
        e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
      ttq.load('${pid}');
      ttq.page();
    }(window, document, 'ttq');
  `);
}

// X（旧Twitter）: 提供コードそのまま出力
function injectXProvided() {
  insertScript(`
    !function(e,t,n,s,u,a){
      e.twq||(s=e.twq=function(){
        s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
      },
      s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js',
      a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))
    }(window,document,'script');
    twq('config','qcuby');
  `);
}

// init
function init() {
  const medium = detectMedium();
  const { mode, ids } = CONFIG;

  if (mode === "all") {
    injectGoogle(ids.google);
    injectXProvided();
    injectTikTok(ids.tiktok);
    return;
  }

  if (medium === "google") {
    injectGoogle(ids.google);
  } else if (medium === "x") {
    injectXProvided();
  } else if (medium === "tiktok") {
    injectTikTok(ids.tiktok);
  }
}

export default { init, CONFIG };
